import React from "react";
import styles from "./TopicImage.module.sass";
import cn from "classnames";
import Card from "../../../../../components/Card";

const TopicImage = ({
                        className,
                        handleUploadFile,
                        imageUrl,
                        fileURL
                    }) => {

    const getDisplayImage = () => {
        // Priorizar fileURL (puede ser base64 o blob URL para preview)
        if (fileURL) return fileURL;
        // Fallback a imageUrl (URL del servidor)
        if (imageUrl) return imageUrl;
        return null;
    };

    const handleRemoveImage = () => {
        // Crear un evento simulado para limpiar la imagen
        handleUploadFile({ target: { files: [] } });
    };

    return (
        <Card className={cn(styles.card, className)} >
            <div className={styles.list}>
                <div className={styles.item}>
                    <div className={styles.category}>Topic image</div>
                    <div className={styles.fieldset}>

                        {/* Image Upload Area */}
                        <div className={styles.uploadArea}>
                            {getDisplayImage() ? (
                                <div className={styles.imagePreview}>
                                    <img
                                        src={getDisplayImage()}
                                        alt="Topic preview"
                                        className={styles.previewImage}
                                    />

                                    {/* Remove Button */}
                                    <button
                                        type="button"
                                        className={styles.removeImageButton}
                                        onClick={handleRemoveImage}
                                        title="Remove image"
                                    >
                                        ×
                                    </button>

                                    {/* Change Image Overlay */}
                                    <div className={styles.imageOverlay}>
                                        <input
                                            type="file"
                                            accept="image/*"
                                            onChange={handleUploadFile}
                                            className={styles.fileInput}
                                            id="topicImageInputChange"
                                        />
                                        <label htmlFor="topicImageInputChange" className={styles.uploadButton}>
                                            Change Image
                                        </label>
                                    </div>
                                </div>
                            ) : (
                                <div className={styles.uploadPlaceholder}>
                                    <input
                                        type="file"
                                        accept="image/*"
                                        onChange={handleUploadFile}
                                        className={styles.fileInput}
                                        id="topicImageInput"
                                    />
                                    <label htmlFor="topicImageInput" className={styles.uploadLabel}>
                                        <div className={styles.uploadIcon}>📷</div>
                                        <div className={styles.uploadText}>+ Upload</div>
                                        <div className={styles.uploadSubtext}>Click to select an image</div>
                                    </label>
                                </div>
                            )}
                        </div>

                        {/* Upload Info */}
                        <div className={styles.uploadInfo}>
                            <p>Recommended size: 400x200px</p>
                            <p>Formats: JPG, PNG, GIF (max 5MB)</p>
                            <p>Image will be converted to base64 format</p>
                        </div>
                    </div>
                </div>
            </div>
        </Card>
    );
};

export default TopicImage;